import { takeEvery, call, put, all, fork } from "redux-saga/effects";
import { RESET_PASSWORD, actionCreators } from "./action";
import reduxSagaFirebase from "../../common/reduxSagaFirebase";
import { actionCreators as actionCreatorsSpinner } from "../Spinner/action";

function* sendPasswordResetEmailSaga(action) {
  const email = action.payload.email;

  try {
    yield put(actionCreatorsSpinner.showSpinner());
    yield call(reduxSagaFirebase.auth.sendPasswordResetEmail, email);
    yield call(action.payload.redirect());
    yield put(actionCreators.saveErrorReponse(null));
    yield put(actionCreatorsSpinner.hideSpinner());
  } catch (error) {
    yield put(actionCreators.saveErrorReponse(error));
    yield put(actionCreatorsSpinner.hideSpinner());
  }
}

function* resetPasswordSaga() {
  yield takeEvery(RESET_PASSWORD, sendPasswordResetEmailSaga);
}

export function* forgotPasswordSaga() {
  yield all([fork(resetPasswordSaga)]);
}
